module.exports = __webpack_public_path__ + "assets/img/Estimation.a209ad10.svg";